/**
 * Quick add from product cards: direct add for single-variant products,
 * or a size-chip picker for products with multiple variants.
 */
async function addToCart(variantId, button) {
  button.disabled = true;
  const originalText = button.textContent;
  button.textContent = window.themeStrings?.adding || 'Adding…';

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    if (!response.ok) throw new Error('Add to cart failed');
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { openDrawer: true } }));
    button.textContent = window.themeStrings?.added || 'Added';
  } catch (error) {
    button.textContent = originalText;
    console.error(error);
  } finally {
    window.setTimeout(() => {
      button.disabled = false;
      button.textContent = originalText;
    }, 1600);
  }
}

document.addEventListener('click', (event) => {
  const directBtn = event.target.closest('[data-quick-add-direct]');
  if (directBtn) {
    event.preventDefault();
    addToCart(directBtn.dataset.variantId, directBtn);
    return;
  }

  const toggleBtn = event.target.closest('[data-quick-add-toggle]');
  if (toggleBtn) {
    event.preventDefault();
    const panel = toggleBtn.nextElementSibling;
    const isHidden = panel.hidden;
    document.querySelectorAll('[data-quick-add-panel]').forEach((p) => { p.hidden = true; });
    panel.hidden = !isHidden;
    return;
  }

  const chip = event.target.closest('.product-card__variant-chip');
  if (chip && !chip.disabled) {
    event.preventDefault();
    addToCart(chip.dataset.variantId, chip);
  }

  const swatch = event.target.closest('[data-color-swatch]');
  if (swatch) {
    event.preventDefault();
    const card = swatch.closest('[data-product-card]');
    if (!card) return;

    card.querySelectorAll('[data-color-swatch]').forEach((btn) => {
      btn.classList.toggle('is-active', btn === swatch);
      btn.setAttribute('aria-pressed', String(btn === swatch));
    });

    const image = card.querySelector('[data-product-card-image]');
    if (image && swatch.dataset.variantImage) {
      image.removeAttribute('srcset');
      image.src = swatch.dataset.variantImage;
    }

    const directBtn = card.querySelector('[data-quick-add-direct]');
    if (directBtn && swatch.dataset.variantId) directBtn.dataset.variantId = swatch.dataset.variantId;
  }
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-quick-add]')) {
    document.querySelectorAll('[data-quick-add-panel]').forEach((p) => { p.hidden = true; });
  }
});
